const dict = {
  languageName: 'Français',
  locale: 'fr',
  fallback: 'en',
  dir: 'ltr',

  // app
  'app.name': 'Kavykhi.Cloud',
  'app.title': (sub) => `${sub} - Kavykhi.Cloud`,

  // themes
  theme: 'Thème',
  'theme.light': 'Clair',
  'theme.dark': 'Sombre',
  'theme.system': 'Système',
  'theme.sakura': 'Sakura',

  // generic
  email: 'E-mail',
  password: 'Mot de passe',
  ok: 'OK',
  cancel: 'Annuler',
  retry: 'Réessayer',
  copy: 'Copier',
  empty: '(aucun élément)',
  loading: 'Chargement...',
  calculating: 'Calcul...',
  error: 'Erreur',

  'in_development': 'Cette page est en cours de développement.',

  // errors
  'error.not_found': 'introuvable',
  'error.name_conflict': 'conflit de nom',
  'error.bad_param': 'paramètre incorrect',
  'error.wrong_auth': 'authentification incorrecte',
  'error.unauthorized': 'non autorisé',
  'error.wrong_credentials': 'identifiants incorrects',
  'error.wrong_provider': 'fournisseur incorrect',
  'error.insufficient_privileges': 'privilèges insuffisants',
  'error.not_empty': 'non vide',
  'error.limit_exceeded': 'limite dépassée',
  'error.already_member': 'déjà membre',
  'error.not_finalized': 'non finalisé',
  'error.already_finalized': 'déjà finalisé',
  'error.unexpected_patch': 'correctif inattendu',
  'error.timeout': 'délai d\'attente dépassé',
  'error.not_patch': 'pas un correctif',
  'error.not_supported': 'non pris en charge',
  'error.unexpected_error': 'erreur inattendue',

  // data sizes
  'datasize.B': 'Octets',
  'datasize.KiB': 'Kio',
  'datasize.MiB': 'Mio',
  'datasize.GiB': 'Gio',
  'datasize.TiB': 'Tio',

  // auth providers
  'auth.provider.steam': 'Steam',
  'auth.provider.github': 'GitHub',
  'auth.provider.gitlab': 'GitLab',
  'auth.provider.itch': 'itch.io',
  'auth.provider.twitch': 'Twitch',
  'auth.provider.discord': 'Discord',
  'auth.provider.google': 'Google',

  // auth dialog
  'auth.dialog.header': 'Authentification',
  'auth.dialog.please_select': 'Veuillez sélectionner votre fournisseur de compte pour vous connecter.',
  'auth.dialog.redirecting_to': (provider) => `Redirection vers ${provider}...`,
  'auth.dialog.remember_me': 'Se souvenir de moi',
  'auth.dialog.log_in': 'Se connecter',
  'auth.dialog.back': 'Retour',
  'auth.dialog.progress_header': 'Authentification...',
  'auth.dialog.error.header': 'Erreur d\'authentification',
  'auth.dialog.error.auth_not_allowed': 'Cet identifiant a été interdit d\'authentification par l\'utilisateur. Veuillez en utiliser un autre.',
  'auth.dialog.error.unknown': 'Paramètres d\'authentification invalides. Veuillez réessayer.',
  'auth.dialog.error.back': 'Retour',

  'user.profile': 'Profil',
  'user.logout': 'Se déconnecter',

  // deploy credential providers
  'deploy_credential_provider.steam': 'Steam',
  'deploy_credential_provider.itch': 'itch.io',

  'page_not_found.header': 'Page non trouvée',
  'page_not_found.message': 'Cette page n\'existe pas.',
  'page_not_found.message2': 'Enfin, elle existe peut-être, mais il n\'y a rien ici. Voici les possibilités.',
  'page_not_found.items': [
    'Quelque chose se trouvait ici auparavant, mais a été supprimé.',
    'Quelque chose s\'y trouve, mais vous n\'y avez pas accès.',
    'Ou quelqu\'un a simplement manqué de précision en copiant-collant le lien.',
  ],

  'home': 'Accueil',
  'home.header.hint': 'Outils cloud pour développeurs indés',
  'home.description': 'Kavykhi.Cloud est une plateforme de développement pour jeux indépendants. Nous prenons en charge les jeux téléchargeables et par navigateur, les builds privés et publics, les branches, les équipes et bien plus encore.',
  'home.auth': 'Se connecter ou s\'inscrire',
  'home.auth.hint': 'Créer un nouveau compte ou se connecter à un compte existant',

  'projects': 'Projets',
  'projects.hint': 'Les projets sur lesquels vous travaillez',
  'projects.project': (project) => `Projet : ${project}`,
  'projects.project.hint': 'projet',
  'projects.no_projects': 'Vous n\'avez pas encore de projet.',
  'projects.new': 'Créer un projet',
  'projects.new_dialog.header': 'Nouveau projet',
  'projects.new_dialog.label': 'Nom du projet',
  'projects.new_dialog.ok': 'Créer le projet',
  'projects.store_page': 'Page publique du magasin',
  'projects.description': 'Description',
  'projects.branches': 'Branches',
  'projects.versions': 'Versions',
  'projects.packages': 'Packages',
  'projects.management': 'Paramètres du projet',
  'projects.management.breadcrumb': 'Paramètres',
  'projects.management.title': (projectTitle) => `${projectTitle} - paramètres`,
  'projects.management.hint': 'paramètres du projet',
  'projects.management.users': 'Membres de l\'équipe',
  'projects.management.users.empty': 'Aucun membre dans l\'équipe.',
  'projects.management.users.role.tester': 'Testeur',
  'projects.management.users.role.developer': 'Développeur',
  'projects.management.users.role.admin': 'Administrateur',
  'projects.management.users.role.owner': 'Propriétaire',
  'projects.management.users.role.starred': 'Favori',
  'projects.management.users.exile': 'Retirer de l\'équipe',
  'projects.management.users.exile.dialog.header': 'Retirer de l\'équipe',
  'projects.management.users.exile.dialog.message': (projectTitle, userTitle) => <>Êtes-vous sûr de vouloir retirer {userTitle} du projet {projectTitle} ?</>,
  'projects.management.users.exile.dialog.ok': 'Retirer de l\'équipe',
  'projects.management.invites.one_time_invite': 'Lien d\'invitation à usage unique',
  'projects.management.invites.one_time_invite.header': 'Lien d\'invitation à usage unique',
  'projects.management.invites.one_time_invite.message': 'Lien d\'invitation à usage unique :',
  'projects.management.invites.one_time_invite.note': 'Valable 24 heures, utilisable une seule fois.',
  'projects.management.invites.new_dialog.header': 'Lien d\'invitation',
  'projects.management.invites.new_dialog.expires': 'Expire dans :',
  'projects.management.invites.new_dialog.expires.indefinite': '(pas d\'expiration)',
  'projects.management.invites.new_dialog.approval.label': 'L\'utilisateur rejoint le projet :',
  'projects.management.invites.new_dialog.approval.not_approved': 'après approbation de l\'admin',
  'projects.management.invites.new_dialog.approval.approved': 'immédiatement',
  'projects.management.invites.new_dialog.seats': 'Limiter les inscriptions :',
  'projects.management.invites.new_dialog.seats.no_limit': '(aucune limite)',
  'projects.management.invites.new_dialog.ok': 'Créer le lien d\'invitation',
  'projects.management.deploy_sites': 'Sites de déploiement',
  'projects.management.deploy_sites.empty': 'Aucun site de déploiement ajouté.',
  'projects.management.deploy_sites.add': 'Ajouter un site de déploiement',
  'projects.management.deploy_sites.delete': 'Supprimer',
  'projects.management.deploy_sites.delete_dialog.header': 'Supprimer le site de déploiement',
  'projects.management.deploy_sites.delete_dialog.message': (provider, site) => <>Êtes-vous sûr de vouloir supprimer le site de déploiement {provider} {site} ?</>,
  'projects.management.deploy_sites.delete_dialog.ok': 'Supprimer le site de déploiement',
  'projects.management.public_access': 'Accès public',
  'projects.management.public_access.enable': 'Activer l\'accès public',
  'projects.management.public_access.enabled': <>Accès public : <strong>autorisé</strong></>,
  'projects.management.public_access.enabled.note': 'Le nom et la description du projet sont publics, ainsi que toutes les branches marquées comme publiques.',
  'projects.management.public_access.enable_dialog.header': 'Activer l\'accès public',
  'projects.management.public_access.enable_dialog.message': (projectTitle) => <>Êtes-vous sûr de vouloir autoriser l\'accès public au projet {projectTitle} ?<br /><br />Cela rendra les informations de base du projet accessibles sans authentification. Vous devrez activer séparément l\'accès public pour chaque branche que vous souhaitez rendre publique.</>,
  'projects.management.public_access.enable_dialog.ok': 'Activer l\'accès public',
  'projects.management.public_access.disable': 'Désactiver l\'accès public',
  'projects.management.public_access.disabled': <>Accès public : <strong>non autorisé</strong></>,
  'projects.management.public_access.disabled.note': 'Le projet est privé. Seuls les membres de l\'équipe du projet peuvent y accéder.',
  'projects.management.public_access.disable_dialog.header': 'Désactiver l\'accès public',
  'projects.management.public_access.disable_dialog.message': (projectTitle) => <>Êtes-vous sûr de vouloir désactiver tout accès public au projet {projectTitle} ?</>,
  'projects.management.public_access.disable_dialog.ok': 'Désactiver l\'accès public',
  'projects.management.public_access.branches': 'Branches publiques',
  'projects.management.manage': 'Gérer le projet',
  'projects.rename': 'Renommer le projet',
  'projects.rename_dialog.header': 'Renommer le projet',
  'projects.rename_dialog.label': 'Nom du projet :',
  'projects.rename_dialog.ok': 'Renommer le projet',
  'projects.edit_description': 'Modifier la description',
  'projects.edit_description_dialog.header': 'Modifier la description du projet',
  'projects.edit_description_dialog.label': 'Description du projet :',
  'projects.edit_description_dialog.ok': 'Modifier la description',
  'projects.leave': 'Quitter le projet',
  'projects.leave_dialog.header': 'Quitter le projet',
  'projects.leave_dialog.message': (projectTitle) => <>Êtes-vous sûr de vouloir quitter le projet {projectTitle} ?</>,
  'projects.leave_dialog.ok': 'Quitter le projet',
  'projects.delete': 'Supprimer le projet',
  'projects.delete_dialog.header': 'Supprimer le projet',
  'projects.delete_dialog.message': (projectTitle) => <>Êtes-vous sûr de vouloir supprimer le projet {projectTitle} ?</>,
  'projects.delete_dialog.ok': 'Supprimer le projet',

  'branches.header': (projectTitle, branchTitle) => `${projectTitle} : ${branchTitle}`,
  'branches.header.hint': 'branche',
  'branches.no_branches': 'Le projet n\'a pas encore de branche',
  'branches.new': 'Créer une branche',
  'branches.new_dialog.header': 'Nouvelle branche',
  'branches.new_dialog.label': 'Nom de la branche',
  'branches.new_dialog.ok': 'Créer la branche',
  'branches.current_version': (version) => <>Version actuelle : {version}</>,
  'branches.current_version.packages': 'Packages de la version actuelle',
  'branches.no_current_version': 'Aucune version actuelle',
  'branches.publish_version.new': 'Publier une nouvelle version',
  'branches.publish_version.existing': 'Republier une version existante',
  'branches.version_history': 'Historique des versions',
  'branches.version_history.empty': 'L\'historique des versions de la branche est vide.',
  'branches.version_history.note_removal': ({ quotaCount, quotaCountText, quotaNonCurrentTime, quotaTime }) => <>La version actuelle de la branche est conservée {quotaTime != null ? <>pendant {quotaTime}</> : <>indéfiniment</>}. Les versions précédentes sont conservées au maximum {quotaNonCurrentTime}. Pas plus de {plural(quotaCount, <>{quotaCountText} version</>, <>{quotaCountText} versions</>)} au total ne sont conservées par branche.</>,
  'branches.manage': 'Gérer la branche',
  'branches.rename': 'Renommer la branche',
  'branches.rename_dialog.header': 'Renommer la branche',
  'branches.rename_dialog.label': 'Nom de la branche :',
  'branches.rename_dialog.ok': 'Renommer la branche',
  'branches.delete': 'Supprimer la branche',
  'branches.delete_dialog.header': 'Supprimer la branche',
  'branches.delete_dialog.message': (branchTitle) => <>Êtes-vous sûr de vouloir supprimer la branche {branchTitle} ?</>,
  'branches.delete_dialog.ok': 'Supprimer la branche',

  'versions.header': (projectTitle, versionTitle) => `${projectTitle} ${versionTitle}`,
  'versions.header.hint': 'version',
  'versions.current': 'Actuelle',
  'versions.previous': 'Précédente',
  'versions.description': 'Description',
  'versions.deploy_to_site.header': 'Publier sur un site',
  'versions.deploy_to_site': 'Publier sur un site',
  'versions.packages': 'Packages',
  'versions.branches': 'Dans les branches',
  'versions.branches.publish': 'Publier sur la branche',
  'versions.branches.empty': 'La version n\'a été publiée dans aucune branche.',
  'versions.new_dialog.header': 'Nouvelle version',
  'versions.new_dialog.label_title': 'Version :',
  'versions.new_dialog.label_branch': 'Branche :',
  'versions.new_dialog.packages.header': 'Packages',
  'versions.new_dialog.packages.empty': 'Aucun package ajouté.',
  'versions.new_dialog.packages.add': 'Ajouter un package',
  'versions.new_dialog.packages.add_existing': 'Ajouter un package déjà téléversé',
  'versions.new_dialog.packages.replace': 'Remplacer le package',
  'versions.new_dialog.packages.edit': 'Modifier le package',
  'versions.new_dialog.ok': 'Créer la version',
  'versions.manage': 'Gérer la version',
  'versions.rename': 'Renommer la version',
  'versions.rename_dialog.header': 'Renommer la version',
  'versions.rename_dialog.label': 'Nom de la version :',
  'versions.rename_dialog.ok': 'Renommer la version',
  'versions.edit_description': 'Modifier la description',
  'versions.edit_description_dialog.header': 'Modifier la description de la version',
  'versions.edit_description_dialog.label': 'Description de la version :',
  'versions.edit_description_dialog.ok': 'Modifier la description',
  'versions.delete': 'Supprimer la version',
  'versions.delete_dialog.header': 'Supprimer la version',
  'versions.delete_dialog.message': (versionTitle) => <>Êtes-vous sûr de vouloir supprimer la version {versionTitle} ?</>,
  'versions.delete_dialog.ok': 'Supprimer la version',

  'versions.publish_dialog.header': 'Publier la version sur une branche',
  'versions.publish_dialog.message': (versionTitle) => <>Choisissez la branche sur laquelle publier la version {versionTitle}.</>,
  'versions.publish_dialog.no_branches': 'Aucune branche dans le projet.',
  'versions.publish_dialog.ok': 'Publier la version',

  'versions.publish_existing_dialog.header': 'Republier la version',
  'versions.publish_existing_dialog.message': 'Dernières versions :',
  'versions.publish_existing_dialog.no_versions': 'Aucune version dans le projet.',
  'versions.publish_existing_dialog.ok': 'Publier la version',

  'packages.header': (projectTitle, packageTitle) => `${projectTitle} : ${packageTitle}`,
  'packages.header.hint': 'Package',
  'packages.download_zip': 'Télécharger en ZIP',
  'packages.download_torrent': 'Télécharger le torrent',
  'packages.total_size': (size) => <>Taille totale : {size}</>,
  'packages.manage': 'Gérer le package',
  'packages.rename': 'Renommer le package',
  'packages.rename_dialog.header': 'Renommer le package',
  'packages.rename_dialog.label': 'Nom du package :',
  'packages.rename_dialog.ok': 'Renommer le package',
  'packages.edit_tags': 'Modifier les tags',
  'packages.edit_tags_dialog.header': 'Modifier les tags du package',
  'packages.edit_tags_dialog.message': (packageTitle) => <>Spécifiez les tags du package {packageTitle} :</>,
  'packages.edit_tags_dialog.ok': 'Définir les tags',
  'packages.entrypoint': (entrypoint) => <>Fichier de lancement : {entrypoint}</>,
  'packages.entrypoint.empty': 'Fichier de lancement non défini.',
  'packages.delete': 'Supprimer le package',
  'packages.delete_dialog.header': 'Supprimer le package',
  'packages.delete_dialog.message': (packageTitle) => <>Êtes-vous sûr de vouloir supprimer le package {packageTitle} ? Il sera supprimé de toutes les versions auxquelles il a été ajouté.</>,
  'packages.delete_dialog.ok': 'Supprimer le package',

  'packages.new_dialog.header': 'Nouveau package',
  'packages.new_dialog.label_title': 'Titre :',
  'packages.new_dialog.title_placeholder': '(depuis les tags)',
  'packages.new_dialog.tags.header': 'Tags',
  'packages.new_dialog.files.header': 'Fichiers',
  'packages.new_dialog.total_size': (size, maximum) => <>Taille totale : {size} {maximum}</>,
  'packages.new_dialog.total_size.maximum': (size) => <>(maximum {size})</>,
  'packages.new_dialog.new_data_size': (size) => <>Taille des nouvelles données : {size}</>,
  'packages.new_dialog.checks.empty': 'Aucun fichier ajouté.',
  'packages.new_dialog.checks.entrypoint.empty': 'Fichier de lancement non défini.',
  'packages.new_dialog.checks.entrypoint.missing': (entrypoint) => <>Le fichier de lancement {entrypoint} n\'existe pas ; l\'avez-vous oublié ? Veuillez spécifier un fichier existant, ou aucun fichier de lancement.</>,
  'packages.new_dialog.checks.entrypoint.missing.action': 'Retirer le fichier de lancement',
  'packages.new_dialog.checks.entrypoint.ext.tag': (fileExt, tag) => <>Le fichier de lancement a l\'extension {fileExt} : suggestion du tag {tag}.</>,
  'packages.new_dialog.checks.entrypoint.ext.tag.action': (tag) => <>Ajouter le tag {tag}</>,
  'packages.new_dialog.checks.entrypoint.ext.html': (fileExt, tag) => <>Le fichier de lancement a l\'extension {fileExt} : ajoutez le tag {tag} pour rendre le package jouable sur navigateur.</>,
  'packages.new_dialog.checks.entrypoint.ext.wrong': (fileExt) => <>Le fichier de lancement a l\'extension {fileExt} : est-ce une erreur ? Ce n\'est généralement pas un type de fichier exécutable.</>,
  'packages.new_dialog.checks.entrypoint.ext.archive': (fileExt) => <>Le fichier de lancement a l\'extension {fileExt} : il est recommandé d\'inclure les fichiers réels plutôt que de les compresser dans une archive.</>,
  'packages.new_dialog.checks.entrypoint.executable': 'Le fichier de lancement n\'est pas marqué comme exécutable',
  'packages.new_dialog.checks.entrypoint.executable.action': 'Le marquer comme exécutable',
  'packages.new_dialog.checks.single_root_dir': 'Il est recommandé de placer les fichiers directement à la racine, plutôt que d\'avoir un dossier unique à la racine.',
  'packages.new_dialog.checks.single_root_dir.action': 'Remplacer le dossier par son contenu',

  'packages.add_existing_dialog.header': 'Ajouter un package',
  'packages.add_existing_dialog.add': (packagesCount) => packagesCount > 0 ? `Ajouter ${plural(packagesCount, `${packagesCount} package`, `${packagesCount} packages`)}` : 'Aucun package sélectionné',
  'packages.add_existing_dialog.message': 'Derniers packages téléversés :',
  'packages.add_existing_dialog.no_packages': 'Aucun package récemment téléversé.',

  'packages.launch': 'Lancer',

  'packages.install': 'Installer',
  'packages.install_dialog.header': 'Installer',
  'packages.install_dialog.workdir.label': 'Dossier de travail :',
  'packages.install_dialog.workdir.value.new': '(créer un nouveau)',
  'packages.install_dialog.workspace.label': 'Créer le dossier sous :',
  'packages.install_dialog.workspace.placeholder': '(sélectionner le dossier racine)',
  'packages.install_dialog.ok': 'Installer',

  'packages.update': 'Mettre à jour',

  'packages.upload.status.existing': 'Depuis la version précédente',
  'packages.upload.status.queued': 'En file d\'attente',
  'packages.upload.status.packing': 'Compression...',
  'packages.upload.status.creating': 'Création...',
  'packages.upload.status.create_retrying': 'Échec de la création, attente et nouvel essai',
  'packages.upload.status.splitting': 'Division...',
  'packages.upload.status.uploading': 'Téléversement...',
  'packages.upload.status.finalizing': 'Finalisation...',
  'packages.upload.status.finalize_retrying': 'Échec de la finalisation, attente et nouvel essai',
  'packages.upload.status.resolving': 'Résolution du correctif...',
  'packages.upload.status.resolve_retrying': 'Échec de la résolution, attente et nouvel essai...',
  'packages.upload.status.done': 'Téléversé avec succès',
  'packages.upload.status.errored': 'Erreur',

  'packages.upload.part.status.queued': 'En file d\'attente',
  'packages.upload.part.status.hashing': 'Calcul de l\'empreinte',
  'packages.upload.part.status.upload_queued': 'Téléversement en file d\'attente',
  'packages.upload.part.status.uploading': 'Téléversement',
  'packages.upload.part.status.upload_retrying': 'Erreur, nouvel essai',
  'packages.upload.part.status.upload_finalizing': 'Finalisation du téléversement',
  'packages.upload.part.status.upload_errored': 'Erreur',
  'packages.upload.part.status.done': 'Téléversé',

  'packages.play': 'Jouer sur navigateur',
  'packages.play.reset': 'Réinitialiser',
  'packages.play.fullscreen': 'Plein écran',

  'deploy_sites.add_dialog.header': 'Ajouter un site de déploiement',
  'deploy_sites.add_dialog.message': (projectTitle) => <>Choisissez un identifiant de déploiement et saisissez l\'URL du site pour les enregistrer comme site de déploiement pour le projet {projectTitle}.</>,
  'deploy_sites.add_dialog.label_credential': 'Identifiant de déploiement :',
  'deploy_sites.add_dialog.select_credential': 'Sélectionner l\'identifiant',
  'deploy_sites.add_dialog.select_credential.new': 'Ajouter un nouvel identifiant...',
  'deploy_sites.add_dialog.label_select_site': 'Sélectionner le site :',
  'deploy_sites.add_dialog.select_credential_first': '(sélectionner d\'abord un identifiant)',
  'deploy_sites.add_dialog.select_site': '(sélectionner le site)',
  'deploy_sites.add_dialog.label_enter_site': 'Ou saisir l\'URL du site :',
  'deploy_sites.add_dialog.ok': 'Ajouter le site',

  'deploy_to_site_dialog.header': 'Publier sur un site',
  'deploy_to_site_dialog.message': (projectTitle, versionTitle) => <>Choisissez le site sur lequel publier la version {versionTitle} de {projectTitle}.</>,
  'deploy_to_site_dialog.label_site': 'Publier sur le site :',
  'deploy_to_site_dialog.select_site': 'Sélectionner le site',
  'deploy_to_site_dialog.select_site.new': 'Ajouter un nouveau site de déploiement...',
  'deploy_to_site_dialog.packages.message.itch': <>Les packages seront publiés sur itch.io à l\'aide de <a href="https://itch.io/docs/butler/pushing.html" target="_blank">butler</a>. Les noms des canaux sont dérivés des tags des packages.</>,
  'deploy_to_site_dialog.deploy': 'Publier',
  'deploy_to_site_dialog.close': 'Fermer',
  'deploy_to_site_dialog.error.no_packages': 'Aucun package à publier.',
  'deploy_to_site_dialog.error.non_unique_channels': ({ packagesCount, packagesCountText, channel }) => <>Impossible de publier plusieurs packages sur un seul canal. Actuellement, {plural(packagesCount, <>{packagesCountText} package est configuré</>, <>{packagesCountText} packages sont configurés</>)} pour être publiés sur le canal {channel}.</>,
  'deploy_to_site_dialog.job.queued': 'En file d\'attente',
  'deploy_to_site_dialog.job.downloading': 'Téléchargement...',
  'deploy_to_site_dialog.job.unpacking': 'Décompression...',
  'deploy_to_site_dialog.job.uploading': 'Publication...',
  'deploy_to_site_dialog.job.succeeded': 'Succès',
  'deploy_to_site_dialog.job.errored': 'Erreur',

  'store': 'Magasin',
  'store.hint': 'Projets publics',
  'store.project.hint': 'Page magasin du projet',
  'store.project.owner': 'Développeur',
  'store.project.description': 'Description',
  'store.project.star': 'Suivre',
  'store.project.starred': 'Suivi',
  'store.project.content': 'Contenu',
  'store.project.content.warning': 'Ce contenu a été fourni par un développeur tiers.',
  'store.project.branch_version': (branchTitle, versionTitle) => <>Branche {branchTitle} : version {versionTitle}</>,
  'store.project.branch_version.published': (branchVersionPublished) => <>Publié le : {branchVersionPublished}</>,

  'me': 'Profil',
  'me.hint': 'Paramètres du profil et identifiants associés',
  'me.rename': 'Renommer le profil',
  'me.rename_dialog.header': 'Renommer le profil',
  'me.rename_dialog.label_title': 'Nom :',
  'me.rename_dialog.ok': 'Renommer le profil',
  'me.credentials': 'Identifiants',
  'me.credentials.hint.auth_allowed': 'Chacun de ces identifiants peut être utilisé pour se connecter à ce compte.',
  'me.credentials.hint.auth_disallowed': 'Ces identifiants sont liés à votre compte, mais ne peuvent pas être utilisés pour se connecter.',
  'me.credentials.empty': 'Aucun identifiant.',
  'me.credentials.empty.auth_allowed.warning': 'Vous risquez de perdre l\'accès à votre compte ! Vous n\'avez lié aucun identifiant pour vous connecter. Veuillez lier un identifiant de connexion dès que possible.',
  'me.credentials.profile_picture.alt': (provider) => `Photo de profil ${dict[`auth.provider.${provider}`]}`,
  'me.credentials.created': (created) => <>ajouté le {created}</>,
  'me.credentials.last_used': (lastUsed) => <>utilisé le {lastUsed}</>,
  'me.credential.unlink': 'Dissocier',
  'me.credential.allow_auth': 'Autoriser la connexion',
  'me.credential.disallow_auth': 'Interdire la connexion',
  'me.credential.display_publicly': 'Afficher publiquement',
  'me.credential.dont_display_publicly': 'Ne pas afficher publiquement',
  'me.credential.link': 'Lier un identifiant',
  'me.credential.link_dialog.header': 'Lier un identifiant',
  'me.credential.link_dialog.message': 'Veuillez sélectionner le fournisseur de compte à lier.',
  'me.credential.unlink_dialog.header': 'Dissocier l\'identifiant',
  'me.credential.unlink_dialog.are_you_sure': (credentialProvider, credentialTitle) => <>Êtes-vous sûr de vouloir dissocier le compte {credentialProvider} ({credentialTitle}) de votre compte Kavykhi.Cloud ?</>,
  'me.credential.unlink_dialog.ok': 'Dissocier l\'identifiant',
  'me.sessions': 'Sessions',
  'me.sessions.hint': 'Voici la liste de vos sessions actives, y compris votre navigateur actuel.',
  'me.sessions.started': (started) => <>commencée le <span class="value">{started}</span></>,
  'me.sessions.last_auth': (lastAuth) => <>active le <span class="value">{lastAuth}</span></>,
  'me.sessions.current': 'Session actuelle',
  'me.sessions.empty': 'Aucune session.',
  'me.sessions.delete': 'Terminer',
  'me.sessions.delete_dialog.header': 'Terminer la session',
  'me.sessions.delete_dialog.message': 'Êtes-vous sûr de vouloir terminer cette session ?',
  'me.sessions.delete_dialog.ok': 'Terminer la session',
  'me.api_tokens': 'Jetons API',
  'me.api_tokens.hint': 'Vous pouvez créer des jetons API ici pour vos scripts d\'automatisation.',
  'me.api_tokens.started': (started) => <>créé le <span class="value">{started}</span></>,
  'me.api_tokens.expires': (expires) => <>expire le <span class="value">{expires}</span></>,
  'me.api_tokens.no_expiration': 'pas d\'expiration',
  'me.api_tokens.empty': 'Aucun jeton API.',
  'me.api_tokens.create': 'Générer un jeton API',
  'me.api_tokens.create_dialog.header': 'Générer un jeton API',
  'me.api_tokens.create_dialog.message': 'Jeton API généré :',
  'me.api_tokens.create_dialog.note': 'Le jeton ne sera plus affiché par la suite, veuillez le conserver précieusement.',
  'me.api_tokens.delete': 'Supprimer',
  'me.api_tokens.delete_dialog.header': 'Supprimer le jeton API',
  'me.api_tokens.delete_dialog.message': 'Êtes-vous sûr de vouloir supprimer ce jeton ?',
  'me.api_tokens.delete_dialog.ok': 'Supprimer le jeton API',
  'me.deploy_credentials': 'Identifiants de déploiement',
  'me.deploy_credentials.hint': 'Les identifiants pour déployer sur des plateformes de publication peuvent être ajoutés ici.',
  'me.deploy_credentials.empty': 'Aucun identifiant de déploiement ajouté.',
  'me.deploy_credential.add': 'Ajouter un identifiant de déploiement',
  'me.deploy_credential.add_dialog.header': 'Ajouter un identifiant de déploiement',
  'me.deploy_credential.add_dialog.label_site': 'Site :',
  'me.deploy_credential.add_dialog.label_title': 'Note :',
  'me.deploy_credential.add_dialog.label_key': 'Clé :',
  'me.deploy_credential.add_dialog.default_title': (date) => `Clé ${date}`,
  'me.deploy_credential.add_dialog.ok': 'Ajouter l\'identifiant',
  'me.deploy_credential.add_dialog.hint.itch': <>Pour générer la clé API itch.io, allez dans les <a href="https://itch.io/user/settings/api-keys" target="_blank">paramètres de votre profil</a> sur itch.io. Vous pouvez utiliser une clé API existante avec pour source "web" ou "wharf". Les clés API avec pour source "Kavykhi.Cloud" ne fonctionneront pas.</>,
  'me.deploy_credential.add_dialog.error.not_supported': (credentialProvider) => <>L\'ajout d\'identifiants {credentialProvider} n\'est pas pris en charge pour le moment.</>,
  'me.deploy_credential.delete': 'Supprimer',
  'me.deploy_credential.delete_dialog.header': 'Supprimer l\'identifiant de déploiement',
  'me.deploy_credential.delete_dialog.message': (credentialTitle, credentialProvider) => <>Êtes-vous sûr de vouloir supprimer l\'identifiant {credentialTitle} pour {credentialProvider} ? Tous les sites de déploiement configurés avec cet identifiant seront également retirés du projet.</>,
  'me.deploy_credential.delete_dialog.ok': 'Supprimer l\'identifiant',
  'me.public_profile': 'Profil public',
  'me.public_profile.public_credentials': 'Identifiants publics',
  'me.public_profile.public_credentials.hint': 'Sélectionnez les identifiants à afficher publiquement.',
  'me.manage': 'Gérer le compte',
  'me.delete': 'Supprimer le compte',
  'me.delete.dialog.header': 'Supprimer le compte',
  'me.delete.dialog.message': (userTitle) => <>Êtes-vous sûr de vouloir supprimer définitivement votre compte Kavykhi.Cloud {userTitle} ?</>,
  'me.delete.dialog.ok': 'Supprimer le compte',

  'invite': 'Invitation',
  'invite.hint': 'Invitation au projet',
  'invite.message.already_member': (projectTitle) => <>Vous êtes déjà membre du projet {projectTitle}.</>,
  'invite.message.join': (projectTitle) => <>Vous avez été invité à rejoindre le projet {projectTitle}.</>,
  'invite.join': 'Rejoindre le projet',

  'local': 'Contenu local',
  'local.hint': 'Contenu installé localement',
  'local.workdirs': 'Packages installés',
  'local.workdirs.empty': 'Aucun package installé.',
  'local.workdir.action.launch': 'Lancer',
  'local.workdir.action.repair': 'Réparer',
  'local.workdir.action.delete': 'Désinstaller',
  'local.workdir.delete_dialog.header': 'Désinstaller le package',
  'local.workdir.delete_dialog.message': (packageTitle) => <>Êtes-vous sûr de vouloir désinstaller le package {packageTitle} de votre appareil ?</>,
  'local.workdir.delete_dialog.ok': 'Désinstaller',
  'local.workspaces': 'Dossiers racines',
  'local.app_not_detected.message': 'L\'application locale Kavykhi.Cloud n\'est pas détectée. Veuillez la télécharger et l\'installer via l\'un des liens ci-dessous. Si elle est déjà installée, assurez-vous qu\'elle est en cours d\'exécution.',

  'local_app.detected': 'Contenu local',

  'error_dialog.header': 'Erreur',
  'error_dialog.messageFunc': (e) => `Erreur : ${dict[`error.${e}`] ?? e}.`,

  'upload_box.choose_files': 'Choisir des fichiers',
  'upload_box.choose_directories': 'Choisir des dossiers',
  'upload_box.add.progress_dialog.header': 'Ajout des fichiers',
  'upload_box.add.progress_dialog.message': 'Traitement des fichiers...',
  'upload_box.delete': (itemsCount) => `Supprimer ${plural(itemsCount, `${itemsCount} élément`, `${itemsCount} éléments`)}`,
  'upload_box.start_upload': 'Démarrer le téléversement',
  'upload_box.drop_area.message': 'Déposez les fichiers et dossiers ici',
  'upload_box.drop_area.box_dropping_message': 'Déposer ici pour placer à la racine',
  'upload_box.entry.explode_folder': 'Remplacer le dossier par son contenu',
  'upload_box.entry.set_entrypoint': 'Définir comme fichier de lancement',
  'upload_box.entry.mark_executable': 'Marquer comme exécutable',
  'upload_box.entry.unmark_executable': 'Retirer le marquage exécutable',
  'upload_box.entry.remove': 'Retirer',

  'package.tags.empty': '(aucun tag)',
  'package.tag.os': 'Système',
  'package.tag.os:windows': 'Windows',
  'package.tag.os:linux': 'Linux',
  'package.tag.os:macos': 'macOS',
  'package.tag.os:android': 'Android',
  'package.tag.os:ios': 'iOS',
  'package.tag.os:web': 'Web',
  'package.tag.arch': 'Architecture',
  'package.tag.arch:x86': 'x86',
  'package.tag.arch:arm': 'ARM',
  'package.tag.bits': 'Bits',
  'package.tag.bits:64': '64 bits',
  'package.tag.bits:32': '32 bits',
  'package.tag.packaging': 'Format',
  'package.tag.packaging:installer': 'Installeur',
  'package.tag.packaging:deb': '.deb',
  'package.tag.packaging:rpm': '.rpm',
  'package.tag.packaging:flatpak': 'Flatpak',
  'package.tag.component': 'Composant',
  'package.tag.component:client': 'Client',
  'package.tag.component:server': 'Serveur',
  'package.tag.runtime': 'Environnement',
  'package.tag.runtime:nodejs': 'Node.js',
  'package.tag.runtime:java': 'Java',
  'package.tag.distro': 'Distribution Linux',
  'package.tag.distro:ubuntu': 'Ubuntu',
  'package.tag.distro:fedora': 'Fedora',
  'package.tag.distro:arch': 'Arch Linux',
  'package.tag.distro:nixos': 'NixOS',

  'docs': 'Docs',
  'docs.page_no_language': 'Non disponible dans cette langue',
  'docs.page_no_language.message': 'Autres versions disponibles pour ce document :',
  'docs.page_no_language.other_link': (doc, lang) => <>({lang}) {doc}</>,

  'social_links.discord': 'Discord',

  'report_content': 'Signaler un contenu',
  'report_content.dialog.header': 'Signaler un contenu',
  'report_content.dialog.link': 'Envoyer le rapport par e-mail',
  'report_content.dialog.message': (email, link) => <>Veuillez cliquer sur le lien pour envoyer votre rapport :<br /><br />{link}<br /><br />Ou écrivez-nous manuellement à {email}</>,
};

export default dict;

const plural = (n: number, one: string, many: string) => n == 1 ? one : many;
